import { gql } from 'graphql-request'

export const getUserQuery = gql`
  query User {
    user {
      abletonLicense
      abletonLicenseAvailable
      featureFlags
      id
      name
      email
      name
      email
      lastSignInAt
      lastCountryCode
      createdAt
      emailVerified
      shouldIdentifyOnCIO
      claims
      profilePictureUrl
      isEmployee
      groups {
        id
        plan
        isOwner
        isPending
        isExpired
        isTrial
        owner {
          name
          email
          avatar
        }
        members {
          name
          email
          avatar
          isPending
          inviteLink
        }
        currentSeats
        nextCycleSeats
        occupiedSeats
        isFull
        inviteLink
        inviteId
      }
      subscription {
        isPro
        isPremium
        isExpiringSoon
        plan
        availableCredits
        proTrialExpiresAt
        subscriptionType
        activeStripeCurrency
        currentMonthlyUsage
        mustCancelRevenuecatPremium
        hasUsedStripeTrial
        groupPlanFreeTrial
        eligibleGroupPlanTrial
        onDemandCredits {
          remaining
          total
          included {
            remaining
            used
            total
          }
          paid {
            remaining
            used
            total
          }
        }
        details {
          pending
          autoRenew
          providerName
          planCycle
          expireDate
          providerGateway
        }
      }
      subscriptions {
        isPro
        isPremium
        isExpiringSoon
        plan
        best
        type
        subscriptionType
        availableCredits
        proTrialExpiresAt
        activeStripeCurrency
        currentMonthlyUsage
        mustCancelRevenuecatPremium
        hasUsedStripeTrial
        onDemandCredits {
          remaining
          total
          included {
            remaining
            used
            total
          }
          paid {
            remaining
            used
            total
          }
        }
        details {
          pending
          autoRenew
          providerName
          planCycle
          expireDate
          providerGateway
        }
      }
      mostRecentSubscription {
        plan
        planCycle
      }
      preferences {
        communication {
          activity {
            push
            email
          }
          updates {
            push
            email
          }
          collaboration {
            push
            email
          }
        }
        defaultSeparation {
          type
          stems
        }
        chordSkillLevel
        demoPlaylist {
          optOut
          hideFromLibrary
        }
      }
      goals
      instruments {
        skillLevel
        instrumentId
      }
      actionNeeded {
        hasTermsToAccept
      }
      userInfo {
        alreadyPurchasedPlan
        campaignHelper
        hasUtmOnSignup
      }
      experiments {
        flag
        variant
      }
    }
  }
`
